import React from "react";
import { Navigate, useLocation } from "react-router-dom";

/**
 * TI-976 — the legacy `/room` entry must PRESERVE the query string when
 * redirecting to `/livekit`: the UM-built launch URL carries `roomid`, `name`,
 * `sessionId` and `inviteToken` (the TI-974 mint credential). A bare
 * `<Navigate to="/livekit">` drops `location.search`, which silently strips
 * the room id AND the mint credential — the join form comes up blank and the
 * token mint is anonymous (401 under `LIVEKIT_MINT_AUTH_MODE=enforce`).
 */
export default function RoomRedirect() {
  const location = useLocation();
  return (
    <Navigate to={{ pathname: "/livekit", search: location.search }} replace />
  );
}
